<template>
	<footer id="contact" class="footer">
		<div class="footer-overlay"></div>
		<div class="container">
			<h2 class="footer-title">联系我们</h2>
			<div class="contact-grid">
				<div v-for="item in contactList" :key="item.name" class="qrcode-card">
					<img :src="item.qr" :alt="`${item.name}微信二维码`" class="qrcode-img" />
					<p class="contact-name">{{ item.name }}</p>
					<p class="contact-phone">{{ item.phone }}</p>
				</div>
			</div>
			<div class="divider"></div>
			<!-- <p class="closing-text">感谢聆听 期待合作</p> -->
			<div class="icp">备案号：冀ICP备17001063号-13</div>
			<div class="icp">公安备案号：冀公网安备13010502002968号</div>
			<div class="icp">© 2026 石家庄榕海网络科技有限公司</div>
			
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'SiteFooter',
		data() {
			return {
				contactList: [{
						name: '张先生',
						phone: '13161072501',
						qr: require('@/assets/zhang.png')
					},
					{
						name: '许女士',
						phone: '15031192537',
						qr: require('@/assets/xu.png')
					},
					{
						name: '安先生',
						phone: '18932907651',
						qr: require('@/assets/an.png')
					}
				]
			}
		}
	}
</script>

<style scoped>
	.footer {
		position: relative;
		padding: 56px 0 24px;
		background: url('https://picsum.photos/id/1025/1920/1080') no-repeat center center;
		background-size: cover;
		overflow: hidden;
	}

	.footer-overlay {
		position: absolute;
		inset: 0;
		background: linear-gradient(135deg, rgba(10, 25, 41, 0.92) 0%, rgba(15, 53, 87, 0.86) 100%);
	}

	.container {
		position: relative;
		z-index: 1;
		max-width: 1240px;
		margin: 0 auto;
		padding: 0 20px;
		text-align: center;
	}

	.footer-title {
		margin: 0 0 34px;
		font-size: 36px;
		line-height: 1.25;
		font-weight: 400;
		letter-spacing: 1px;
		color: rgba(255, 255, 255, 0.92);
	}

	.contact-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 16px;
		margin-bottom: 30px;
	}

	.qrcode-card {
		padding: 16px;
		border-radius: 14px;
		border: 1px solid rgba(255, 255, 255, 0.12);
		background: rgba(255, 255, 255, 0.06);
		backdrop-filter: blur(4px);
		transition: all 0.3s ease;
	}

	.qrcode-card:hover {
		transform: translateY(-8px);
		box-shadow: 0 12px 30px rgba(59, 130, 246, 0.25);
	}

	.qrcode-img {
		width: 120px;
		height: 120px;
		margin: 0 auto 12px;
		border-radius: 8px;
		object-fit: cover;
	}

	.contact-name {
		margin: 0 0 6px;
		font-size: 24px;
		line-height: 1.2;
		font-weight: 400;
		color: rgba(255, 255, 255, 0.96);
	}

	.contact-phone {
		margin: 0;
		font-size: 20px;
		line-height: 1.2;
		color: rgba(226, 232, 240, 0.92);
	}

	.divider {
		width: 60%;
		height: 1px;
		margin: 0 auto 18px;
		background: rgba(255, 255, 255, 0.24);
	}

	.closing-text {
		margin: 0;
		font-size: 44px;
		line-height: 1.3;
		font-weight: 300;
		letter-spacing: 1px;
		color: rgba(255, 255, 255, 0.82);
	}

	.icp {
		/* margin-top: 24px; */
		margin-bottom: 6px;
		font-size: 12px;
		color: rgba(255, 255, 255, 0.5);
	}

	@media (max-width: 1024px) {
		.footer {
			padding: 46px 0 20px;
		}

		.footer-title {
			font-size: 30px;
			margin-bottom: 24px;
		}

		.contact-grid {
			gap: 12px;
		}

		.qrcode-img {
			width: 104px;
			height: 104px;
		}

		.contact-name {
			font-size: 22px;
		}

		.contact-phone {
			font-size: 18px;
		}

		.closing-text {
			font-size: 36px;
		}
	}

	@media (max-width: 768px) {
		.footer {
			padding: 36px 0 18px;
		}

		.container {
			padding: 0 14px;
		}

		.footer-title {
			font-size: 28px;
			margin-bottom: 20px;
		}

		.contact-grid {
			grid-template-columns: 1fr;
			gap: 10px;
			margin-bottom: 20px;
		}

		.qrcode-img {
			width: 92px;
			height: 92px;
		}

		.contact-name {
			font-size: 20px;
		}

		.contact-phone {
			font-size: 16px;
		}

		.divider {
			width: 88%;
			margin-bottom: 14px;
		}

		.closing-text {
			font-size: 30px;
		}

		.icp {
			font-size: 11px;
		}
	}
</style>